var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "" } },
    [
      _c("attach-payment-dialog", {
        attrs: {
          "load-item": _vm.loadItem,
          strategy: _vm.attachPaymentStrategy
        },
        on: {
          refresh: function($event) {
            return _vm.$emit("reload")
          }
        },
        model: {
          value: _vm.showAttachDialog,
          callback: function($$v) {
            _vm.showAttachDialog = $$v
          },
          expression: "showAttachDialog"
        }
      }),
      _vm._v(" "),
      _c(
        "v-toolbar",
        { attrs: { extended: _vm.isMobile, dense: !_vm.isMobile, flat: "" } },
        [
          (_vm.invoice && _vm.verifiedCustomer) ||
          (_vm.bill && _vm.verifiedVendor)
            ? _c("v-icon", { attrs: { color: "green" } }, [
                _vm._v("\n        verified_user\n      ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("v-toolbar-title", { attrs: { color: "primary" } }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.invoice ? _vm.customer.name : _vm.vendor.name) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "template",
            { slot: _vm.isMobile ? "extension" : "default" },
            [
              _c(
                "v-toolbar-items",
                { attrs: { slot: "toolbarItems" }, slot: "toolbarItems" },
                [
                  _vm.invoice
                    ? [
                        _vm.isQuickbooksConnected(_vm.company) &&
                        !_vm.isMultiTransactionExportModeEnabled
                          ? _c("v-quickbooks-billing-btn", {
                              attrs: {
                                transaction: _vm.transaction,
                                "invoicing-company": _vm.company,
                                disabled: false,
                                loading: false
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isXeroConnected(_vm.company) &&
                        !_vm.isMultiTransactionExportModeEnabled
                          ? _c("v-xero-billing-btn", {
                              attrs: {
                                contract: _vm.transaction,
                                disabled: false,
                                loading: _vm.loadingBtn,
                                "invoicing-company": _vm.company
                              },
                              on: {
                                invoiceCreated: function($event) {
                                  return _vm.refreshItem(_vm.transaction)
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { flat: "", color: "accent" },
                            on: {
                              click: function($event) {
                                return _vm.openAttachDialog(
                                  _vm.transaction,
                                  _vm.ATTACH_INVOICE
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "v-layout",
                              { attrs: { column: "" } },
                              [
                                _c("v-icon", [_vm._v("receipt")]),
                                _vm._v(
                                  "\n                Invoiced\n              "
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { flat: "", color: "accent" },
                            on: {
                              click: function($event) {
                                return _vm.openAttachDialog(
                                  _vm.transaction,
                                  _vm.ACK_PAYMENT
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "v-layout",
                              { attrs: { column: "" } },
                              [
                                _c("v-icon", [_vm._v("check_circle")]),
                                _vm._v("\n                Paid\n              ")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.bill
                    ? [
                        _c(
                          "v-btn",
                          {
                            attrs: { flat: "", color: "accent" },
                            on: {
                              click: function($event) {
                                return _vm.openAttachDialog(
                                  _vm.transaction,
                                  _vm.APPLY_PAYMENT
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "v-layout",
                              { attrs: { column: "" } },
                              [
                                _c("v-icon", [_vm._v("attach_money")]),
                                _vm._v("\n                Pay\n              ")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.canCancelTransaction
                    ? _c(
                        "v-btn",
                        {
                          attrs: { flat: "", color: "accent" },
                          on: {
                            click: function($event) {
                              return _vm.cancelTransaction()
                            }
                          }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { column: "" } },
                            [
                              _c("v-icon", [_vm._v("highlight_off")]),
                              _vm._v("\n              Cancel\n            ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "green darken-3", attrs: { flat: "" } },
        [
          _c(
            "v-stepper",
            {
              staticClass: "my-3 pt-2 arrow-stepper white",
              attrs: {
                value: _vm.paymentProgressStatusNumber,
                "alt-labels": ""
              }
            },
            [
              _c(
                "v-stepper-header",
                [
                  _c(
                    "v-stepper-step",
                    {
                      staticClass: "py-0",
                      attrs: {
                        step: "1",
                        complete: _vm.paymentProgressStatusNumber > 1
                      }
                    },
                    [_vm._v("\n          Open\n        ")]
                  ),
                  _vm._v(" "),
                  _c("v-divider", {
                    class: { completed: _vm.paymentProgressStatusNumber > 1 }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-stepper-step",
                    {
                      staticClass: "py-0",
                      attrs: {
                        step: "2",
                        complete: _vm.paymentProgressStatusNumber >= 2
                      }
                    },
                    [
                      _vm._v("\n          Invoiced\n          "),
                      !_vm.isMobile && _vm.invoiceTime
                        ? _c("small", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm._f("formatDate")(_vm.invoiceTime)) +
                                "\n          "
                            )
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-divider", {
                    class: { completed: _vm.paymentProgressStatusNumber >= 2 }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-stepper-step",
                    {
                      staticClass: "py-0",
                      attrs: {
                        step: "3",
                        complete: _vm.paymentProgressStatusNumber > 3
                      }
                    },
                    [
                      _vm._v("\n          Remitted Payment\n          "),
                      !_vm.isMobile && _vm.paymentTime
                        ? _c("small", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm._f("formatDate")(_vm.paymentTime)) +
                                "\n          "
                            )
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-divider", {
                    class: { completed: _vm.paymentProgressStatusNumber > 3 }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-stepper-step",
                    {
                      staticClass: "py-0",
                      attrs: {
                        step: "4",
                        complete: _vm.paymentProgressStatusNumber === 4
                      }
                    },
                    [
                      _vm._v("\n          Received Payment\n          "),
                      !_vm.isMobile && _vm.receivedPaymentTime
                        ? _c("small", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("formatDate")(_vm.receivedPaymentTime)
                                ) +
                                "\n          "
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-list",
        [
          _vm.bill
            ? _c("v-subheader", [
                _vm._v("Bill Overview (" + _vm._s(_vm.transaction.status) + ")")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.invoice
            ? _c("v-subheader", [
                _vm._v(
                  "Invoice Overview (" + _vm._s(_vm.transaction.status) + ")"
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-list-tile",
            [
              _c(
                "v-list-tile-avatar",
                [_c("v-icon", [_vm._v("attach_money")])],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-tile-content",
                [
                  _c("v-list-tile-title", [
                    _vm._v("$" + _vm._s(_vm.transaction.amount))
                  ]),
                  _vm._v(" "),
                  _c("v-list-tile-sub-title", [
                    _vm._v(_vm._s(_vm.transaction.description))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-tile",
            [
              _c("v-list-tile-avatar", [_c("v-icon", [_vm._v("face")])], 1),
              _vm._v(" "),
              _c(
                "v-list-tile-content",
                [
                  _c("v-list-tile-title", [
                    _vm._v(_vm._s(_vm.transaction.customer.companyName))
                  ]),
                  _vm._v(" "),
                  _vm.customerQbCustomerName
                    ? _c("v-list-tile-sub-title", [
                        _vm._v(_vm._s(_vm.customerQbCustomerName))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.verifiedCustomer
                ? _c(
                    "v-list-tile-action",
                    [
                      _c("v-icon", { attrs: { color: "green" } }, [
                        _vm._v("verified_user")
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-tile",
            [
              _c("v-list-tile-avatar", [_c("v-icon", [_vm._v("money")])], 1),
              _vm._v(" "),
              _c(
                "v-list-tile-content",
                [
                  _c("v-list-tile-title", [
                    _vm._v(_vm._s(_vm.transaction.vendor.companyName))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm.verifiedVendor
                ? _c(
                    "v-list-tile-action",
                    [
                      _c("v-icon", { attrs: { color: "green" } }, [
                        _vm._v("verified_user")
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("v-subheader", [_vm._v("Load Overview")]),
          _vm._v(" "),
          _c(
            "v-list-tile",
            [
              _c(
                "v-list-tile-avatar",
                [
                  _c("v-icon", { attrs: { color: _vm.bookedLoadIcon.color } }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.bookedLoadIcon.icon) +
                        "\n        "
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-tile-content",
                [
                  _c("v-list-tile-title", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.bookedLoadIcon.description) +
                        "\n        "
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-tile",
            [
              _c("v-list-tile-avatar", [_c("v-icon", [_vm._v("place")])], 1),
              _vm._v(" "),
              _c(
                "v-list-tile-content",
                [
                  _c("v-list-tile-title", [
                    _vm._v(
                      _vm._s(
                        _vm.shipper.company
                          ? _vm.shipper.company.name
                          : _vm.shipper.location.googlePlace.placeName
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-list-tile-sub-title", [
                    _vm._v(
                      _vm._s(_vm.shipper.location.googlePlace.formattedAddress)
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-tile",
            [
              _c(
                "v-list-tile-avatar",
                [_c("v-icon", [_vm._v("outlined_flag")])],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-tile-content",
                [
                  _c("v-list-tile-title", [
                    _vm._v(
                      _vm._s(
                        _vm.receiver.company
                          ? _vm.receiver.company.name
                          : _vm.receiver.location.googlePlace.placeName
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-list-tile-sub-title", [
                    _vm._v(
                      _vm._s(_vm.receiver.location.googlePlace.formattedAddress)
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-tile",
            [
              _c("v-list-tile-avatar", [_c("v-icon", [_vm._v("share")])], 1),
              _vm._v(" "),
              _c(
                "v-list-tile-content",
                [
                  _c("v-list-tile-title", [
                    _vm._v(_vm._s(_vm.dispatchCompanyName))
                  ]),
                  _vm._v(" "),
                  _vm.dispatchQbVendorName
                    ? _c("v-list-tile-sub-title", [
                        _vm._v(_vm._s(_vm.dispatchQbVendorName))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.dispatchCompanyVerified
                ? _c(
                    "v-list-tile-action",
                    [
                      _c("v-icon", { attrs: { color: "green" } }, [
                        _vm._v("verified_user")
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-tile",
            [
              _c(
                "v-list-tile-avatar",
                [_c("v-icon", [_vm._v("local_shipping")])],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-tile-content",
                [
                  _c("v-list-tile-title", [
                    _vm._v(
                      _vm._s(
                        _vm.transactionHaulingCompany(_vm.transaction).name
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _vm.truckingCompanyQbVendorname
                    ? _c("v-list-tile-sub-title", [
                        _vm._v(_vm._s(_vm.truckingCompanyQbVendorname))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.isVendorAssigned
                ? _c("v-list-tile-action", [
                    _c("img", {
                      attrs: {
                        height: "24",
                        width: "24",
                        src: "/static/Quickbooks-Logo.png"
                      }
                    })
                  ])
                : _vm.verifiedVendor
                ? _c(
                    "v-list-tile-action",
                    [
                      _c("v-icon", { attrs: { color: "green" } }, [
                        _vm._v("verified_user")
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.driverInfo
            ? _c(
                "v-list-tile",
                [
                  _c(
                    "v-list-tile-avatar",
                    [
                      _c("bqa-certificate-icon", {
                        attrs: { small: "", driver: _vm.driverInfo }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-content",
                    [
                      _c("v-list-tile-title", [
                        _vm._v(_vm._s(_vm.driverInfo.displayName))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.billOfLading
            ? _c(
                "v-list-tile",
                [
                  _c(
                    "v-list-tile-avatar",
                    [_c("v-icon", [_vm._v("attachment")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-content",
                    [
                      _vm.billOfLading.name
                        ? [
                            _vm.billOfLading.link
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "primary--text mx-0 px-0",
                                    attrs: { flat: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.openBillOfLading(
                                          _vm.billOfLading.link
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.billOfLading.name) +
                                        "\n          "
                                    )
                                  ]
                                )
                              : [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.billOfLading.name) +
                                      "\n            "
                                  ),
                                  _c("span", { staticClass: "font-italic" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.billOfLading.status) +
                                        "\n            "
                                    )
                                  ])
                                ]
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.billOfLadingNumber
                        ? _c("v-list-tile-sub-title", [
                            _c("span", { staticClass: "font-italic" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("terms.bill-of-lading")) +
                                  " Number: " +
                                  _vm._s(_vm.billOfLadingNumber) +
                                  "\n          "
                              )
                            ])
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.directDispatch
            ? _c(
                "v-list-tile",
                [
                  _c(
                    "v-list-tile-avatar",
                    [_c("v-icon", [_vm._v("headset_mic")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-content",
                    [
                      _c("v-list-tile-title", [
                        _vm._v(_vm._s(_vm.directDispatchDriverName))
                      ]),
                      _vm._v(" "),
                      _vm.directDispatchQbVendorName
                        ? _c("v-list-tile-sub-title", [
                            _vm._v(_vm._s(_vm.directDispatchQbVendorName))
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.transaction.load.delivery.when
            ? _c(
                "v-list-tile",
                [
                  _c("v-list-tile-avatar"),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-content",
                    [
                      _c("v-list-tile-title", [
                        _vm._v(
                          "Delivered " +
                            _vm._s(_vm.transaction.load.delivery.animalCount)
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-sub-title",
                        { staticClass: "font-italic" },
                        [
                          _vm._v(
                            "Delivery Weight: " +
                              _vm._s(
                                _vm.transaction.load.delivery.animalWeight ||
                                  _vm.transaction.load.delivery
                                    .animalWeightPounds
                              )
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.transaction.load.pickup.when
            ? _c(
                "v-list-tile",
                [
                  _c("v-list-tile-avatar"),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-content",
                    [
                      _c("v-list-tile-title", [
                        _vm._v(
                          "Picked Up " +
                            _vm._s(_vm.transaction.load.pickup.animalCount)
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-sub-title",
                        { staticClass: "font-italic" },
                        [
                          _vm._v(
                            "Pickup Weight: " +
                              _vm._s(
                                _vm.transaction.load.pickup.animalWeight ||
                                  _vm.transaction.load.pickup.animalWeightPounds
                              )
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      false
        ? _c(
            "v-card",
            { staticClass: "pb-3 grey lighten-3", attrs: { flat: "" } },
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "mt-2",
                  attrs: {
                    flat: "",
                    color: "grey lighten-3",
                    extended: "",
                    "extension-height": "100"
                  }
                },
                [
                  _c("v-toolbar-title", [
                    _vm._v("\n        Load Progress\n      ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    {
                      staticClass: "white",
                      attrs: { slot: "extension", column: "" },
                      slot: "extension"
                    },
                    [
                      _c("v-load-progress-stepper", {
                        attrs: { load: _vm.transaction.load }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b186536", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b186536","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoWidgets/LoadTransactionStatusDetails.vue
// module id = null
// module chunks = 